import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {faBoxOpen} from "@fortawesome/free-solid-svg-icons";
import styles from "./EmptyState.module.scss";

export interface EmptyStateProps {
    /** FontAwesome icon shown above the title. Falls back to a neutral box icon when omitted.
     *  Pass an icon definition directly (e.g. faFileInvoice) — NOT the FlintIcon enum, which
     *  only covers the fixed action-button icon set. */
    icon?: IconDefinition;
    /** Page-specific heading, e.g. "No orders found". Already translated by the caller. */
    title: string;
    /** Optional page-specific explanatory line. Already translated by the caller. */
    description?: string;
    /** Optional hint line, e.g. "Try changing your filters or search criteria." Already translated. */
    hint?: string;
}

/**
 * Shared empty-state placeholder for grid/list pages: a centered icon + title +
 * optional description + optional hint, shown when a list has zero rows.
 *
 * Logic-free by design — the consumer decides WHEN to render it (see
 * FlintGridWrapper's `emptyState` prop, which gates on "load finished with no rows").
 */
export default function EmptyState(props: EmptyStateProps) {
    return (
        <div className={styles.emptyState} role="status" aria-live="polite">
            <FontAwesomeIcon icon={props.icon ?? faBoxOpen} className={styles.icon}/>
            <div className={styles.title}>{props.title}</div>
            {props.description && <div className={styles.description}>{props.description}</div>}
            {props.hint && <div className={styles.hint}>{props.hint}</div>}
        </div>
    );
}
